import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-829ddb4a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"header row\" data-v-829ddb4a><div class=\"header-text col-md-8 col-sm-10\" data-v-829ddb4a><h1 data-v-829ddb4a>Book an <strong style=\"color:red;\" data-v-829ddb4a>Advisory</strong> Session</h1><p data-v-829ddb4a> Lorem ipsum dolor sit amet, consectetur adipisicing elit. Harum tempora reprehenderit corporis id expedita. Eveniet fuga voluptas reprehenderit voluptatem quos ad deserunt. </p></div></div><div class=\"header-img\" data-v-829ddb4a></div><h1 class=\"form-text\" data-v-829ddb4a>Book a Session</h1>", 3)
const _hoisted_5 = { class: "form" }
const _hoisted_6 = { class: "form-item" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "fullname" }, "Full Name", -1))
const _hoisted_8 = { class: "form-item" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "email" }, "Email", -1))
const _hoisted_10 = { class: "form-item" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "number" }, "Phone Number", -1))
const _hoisted_12 = { class: "form-item" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "number" }, "Company Name", -1))
const _hoisted_14 = { class: "row" }
const _hoisted_15 = { class: "form-item col-md-5" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "date" }, "Date", -1))
const _hoisted_17 = { class: "form-item col-md-5" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "time" }, "Time", -1))
const _hoisted_19 = { class: "form-item" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "purpose" }, "Purpose", -1))
const _hoisted_21 = {
  class: "mt-3",
  type: "submit"
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bottom" }, [
  /*#__PURE__*/_createElementVNode("span"),
  /*#__PURE__*/_createElementVNode("span")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Navbar = _resolveComponent("Navbar")!
  const _component_Footer = _resolveComponent("Footer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Navbar),
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("form", {
          class: "book-form",
          onSubmit: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (_ctx.bookings()), ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.booking.full_name) = $event)),
              placeholder: "Enter Full Name",
              id: "fullname"
            }, null, 512), [
              [_vModelText, _ctx.booking.full_name]
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.full_name.$errors, (error) => {
              return (_openBlock(), _createElementBlock("span", {
                key: error.$uid,
                class: "error"
              }, _toDisplayString(error.$message), 1))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _withDirectives(_createElementVNode("input", {
              type: "email",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.booking.email) = $event)),
              placeholder: "Enter your email",
              id: "email"
            }, null, 512), [
              [_vModelText, _ctx.booking.email]
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.email.$errors, (error) => {
              return (_openBlock(), _createElementBlock("span", {
                key: error.$uid,
                class: "error"
              }, _toDisplayString(error.$message), 1))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _withDirectives(_createElementVNode("input", {
              type: "tel",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.booking.phone_num) = $event)),
              placeholder: "Enter Phone Number",
              id: "number"
            }, null, 512), [
              [_vModelText, _ctx.booking.phone_num]
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.phone_num.$errors, (error) => {
              return (_openBlock(), _createElementBlock("span", {
                key: error.$uid,
                class: "error"
              }, _toDisplayString(error.$message), 1))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_12, [
            _hoisted_13,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.booking.company_name) = $event)),
              placeholder: "Enter name of Your Company",
              id: "number"
            }, null, 512), [
              [_vModelText, _ctx.booking.company_name]
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.company_name.$errors, (error) => {
              return (_openBlock(), _createElementBlock("span", {
                key: error.$uid,
                class: "error"
              }, _toDisplayString(error.$message), 1))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _hoisted_16,
              _withDirectives(_createElementVNode("input", {
                type: "date",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.booking.date) = $event)),
                placeholder: "Enter name of Your Company",
                id: "date"
              }, null, 512), [
                [_vModelText, _ctx.booking.date]
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.date.$errors, (error) => {
                return (_openBlock(), _createElementBlock("span", {
                  key: error.$uid,
                  class: "error"
                }, _toDisplayString(error.$message), 1))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_17, [
              _hoisted_18,
              _withDirectives(_createElementVNode("input", {
                type: "time",
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.booking.time) = $event)),
                id: "time"
              }, null, 512), [
                [_vModelText, _ctx.booking.time]
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.time.$errors, (error) => {
                return (_openBlock(), _createElementBlock("span", {
                  key: error.$uid,
                  class: "error"
                }, _toDisplayString(error.$message), 1))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_19, [
            _hoisted_20,
            _withDirectives(_createElementVNode("textarea", {
              name: "purpose",
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.booking.purpose) = $event)),
              id: "purpose",
              placeholder: "Purpose for Session"
            }, null, 512), [
              [_vModelText, _ctx.booking.purpose]
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.purpose.$errors, (error) => {
              return (_openBlock(), _createElementBlock("span", {
                key: error.$uid,
                class: "error"
              }, _toDisplayString(error.$message), 1))
            }), 128))
          ]),
          _createElementVNode("button", _hoisted_21, _toDisplayString(_ctx.loader), 1)
        ], 32)
      ]),
      _hoisted_22,
      _createVNode(_component_Footer)
    ])
  ], 64))
}